import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_LT: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Fitnesas',
  components_header_media_1: 'Vyrams',
  components_header_media_2: 'Moterims',
  components_header_media_multi_content_2: 'Joga',
  components_header_media_multi_content_3: 'Pilatesas',
  hero_text: 'Treniruokitės protingiau, jauskitės geriau.',
  hero_button_text: 'Pradėkite dabar',
  components_ressources_subheader_text: 'Vadovai ir patarimai',
  components_ressources_span_text: 'Jame derinamas žemiškas jogos dėmesys, kontroliuojamas Pilateso tikslumas ir dinamiškas jėgos treniruočių iššūkis, siekiant palaikyti visavertį ir sveiką gyvenimo būdą.',
  components_ressources_card_1_title: 'Jogos patarimai',
  components_ressources_card_1_text: 'Trumpas vadovas geresnei pusiausvyrai, kvėpavimui ir tėkmės pojūčiui.',
  components_ressources_card_2_title: 'Pilateso patarimai',
  components_ressources_card_2_text: 'Paprasti patarimai, kaip sustiprinti pagrindinius raumenis ir pagerinti kontrolę.',
  components_notes_and_google_title_1: 'Stiprinkite jėgas',
  components_notes_and_google_title_2: 'Jogos ramybė',
  components_notes_and_google_title_3: 'Pilateso šerdis',
  media_content_section_multi_1_subheader_text: 'Mokymo vaizdo įrašai',
  media_content_section_multi_2_subheader_text: 'Jogos vaizdo įrašai',
  media_content_section_multi_3_subheader_text: 'Pilateso vaizdo įrašai',
  text_media_1: 'Vyrai',
  text_media_2: 'Moterys',
  page_media_content_menu_biceps: 'Bicepsas',
  page_media_content_menu_triceps: 'Tricepsas',
  page_media_content_menu_back: 'Atgal',
  page_media_content_menu_chest: 'Krūtinė',
  page_media_content_menu_legs: 'Kojos',
  page_media_content_menu_shoulders: 'Pečiai',
  page_media_content_menu_abdominals: 'Pilvo raumenys',
  components_text1_subheader_text: 'Sveika mityba jūsų aktyviam gyvenimui',
  components_text1_span_text: 'Sveiki receptai, kurie padės jums treniruotis ir gerins jūsų savijautą.',
  components_footer_text: 'Stiprinkite savo kūną, subalansuokite protą ir judėkite prasmingai – tai jūsų vieta sporto salei, jogai ir pilatesui.',
};